module.exports = __webpack_public_path__ + "static/media/favicon-scmp711.7a96ad8f.ico";